import { SECTIONS } from "@/components/sectionConfig";

export const DraftWatermark = ({ show }) => !show ? null : (
  <div aria-hidden className="print-watermark hidden fixed inset-0 z-0 items-center justify-center pointer-events-none select-none" data-testid="pdf-draft-watermark">
    <span className="font-display font-extrabold tracking-[0.2em]" style={{ fontSize: "150px", transform: "rotate(-35deg)" }}>DRAFT</span>
  </div>
);

export const ImprovementReport = ({ imp }) => {
  if (!imp) return null;
  const names = (imp.sections || []).map((k) => SECTIONS.find((s) => s.key === k)?.title || k);
  return (
    <div className="hidden print:block print-break px-10 py-8" style={{ breakAfter: "page" }} data-testid="pdf-improvement-report">
      <p className="text-xs uppercase tracking-[0.3em] font-semibold mb-2" style={{ color: "var(--brand-accent, #059669)" }}>{imp.to_score > imp.from_score ? "Score improvement report" : "Plan revision report"}</p>
      <h2 className="text-3xl font-extrabold mb-8" style={{ fontFamily: "Outfit" }}>{imp.to_score > imp.from_score ? "Path to a higher score" : "Score review"}</h2>
      <div className="flex items-center justify-center gap-10 border rounded-md py-6 mb-6">
        <div className="text-center"><p className="text-xs uppercase tracking-wider mb-1">Before</p><p className="text-6xl font-extrabold">{imp.from_score}</p><p className="text-sm">{imp.from_verdict}</p></div>
        <p className="text-4xl">→</p>
        <div className="text-center"><p className="text-xs uppercase tracking-wider mb-1">After</p><p className="text-6xl font-extrabold">{imp.to_score}</p><p className="text-sm">{imp.to_verdict}</p></div>
      </div>
      {imp.summary && <p className="text-sm leading-relaxed mb-6">{imp.summary}</p>}
      <p className="text-xs uppercase tracking-wider font-semibold mb-3">What changed in the plan</p>
      <ol className="space-y-3 mb-6">
        {(imp.changes || []).map((c, i) => (
          <li key={i} className="flex gap-3 text-sm"><span className="font-bold">{i + 1}.</span><span><span className="font-semibold">{c.title}. </span>{c.change}</span></li>
        ))}
      </ol>
      {names.length > 0 && <p className="text-xs">Sections revised: {names.join(", ")}</p>}
    </div>
  );
};
